import React, { Component } from "react";
import { Grid, Fab, } from "@material-ui/core";

class SystemLog extends Component {
    render() {
        let { log, } = this.props;
        return (
            <div style={{ padding: "8px 0" }}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item style={{display: 'flex', alignItems: 'center'}}>
                        <Fab 
                            className="overflow-hidden" 
                            color="secondary" 
                            size="small"
                            style={{ width: '36px', height: '36px', minHeight: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}
                        >
                            <span style={{color: 'white', margin: 0, fontWeight: 600, fontSize: '1rem'}} className={"color_" + log.color}>
                                {log.color.toUpperCase()}
                            </span>
                        </Fab>
                    </Grid>
                    <Grid item xs>
                        <div className="font-weight-500" style={{lineHeight: 1.4, color: '#37474f'}} dangerouslySetInnerHTML={{ __html: log.template }} />
                        <div className="mt-4 font-size-13" style={{color: '#90a4ae'}}>{log.date}, {log.time}</div>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default SystemLog